import { useEffect } from "react";

/**
 * @typedef {Object.<string, () => void>} KeyMapObj
 * @property {() => void} keycodeAddPointTeamA - Callback pour ajouter un point à l'équipe A
 * @property {() => void} keycodeAddPointTeamB - Callback pour ajouter un point à l'équipe B
 * @property {() => void} keycodeResetScoring - Callback pour réinitialiser le score
 * @property {() => void} keycodeBackScoring - Callback pour annuler le dernier point
 * @property {() => void} keycodeAddMatch - Callback pour ajouter un match
 */

/**
 * @param {KeyMapObj} keyMap
 */
export function useKeyboard(keyMap) {
  useEffect(() => {
    const _onKeyDownBind = _onKeyDown.bind(null);
    window.addEventListener("keydown", _onKeyDownBind);
    return () => {
      window.removeEventListener("keydown", _onKeyDownBind);
    };
  }, [keyMap]);

  /**
   * Gestion du keyDown sur une touche clavier
   * @param {KeyboardEvent} e - Événement lors du keyDown sur une touche clavier
   * @private
   */
  function _onKeyDown(e) {
    var action = keyMap[e.key];
    if (action) {
      action();
    }
  }
}
